import { esES, frFR, itIT, enUS } from "@mui/x-data-grid";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const useUpdateDataGridLanguage = () => {
  const { i18n } = useTranslation();

  let muiLanguage = enUS;

  switch (i18n.language) {
    case "en": {
      muiLanguage = enUS;
      break;
    }
    case "it": {
      muiLanguage = itIT;
      break;
    }
    case "es": {
      muiLanguage = esES;
      break;
    }
    case "ca": {
      muiLanguage = esES;
      break;
    }
    case "fr": {
      muiLanguage = frFR;
      break;
    }
    default:
      muiLanguage = enUS;
      break;
  }

  return useMemo(() => muiLanguage);
};
export default useUpdateDataGridLanguage;
